/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal merchant-portal-campaign-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    CreateSmartPromotionRequest,
    CreateSmartPromotionResponse,
    GetCurrentSmartPromotionRequest,
    GetCurrentSmartPromotionResponse,
    GetSmartPromotionConfigRequest,
    GetSmartPromotionDetailsRequest,
    GetSmartPromotionDetailsResponse,
    GetSmartPromotionPerformanceRequest,
    GetSmartPromotionPerformanceResponse,
    SmartPromotionV2Config,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}



class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public smartpromotionsV2CreateSmartPromotion = async (body: CreateSmartPromotionRequest, opts?: TRequestOptions): Promise<CreateSmartPromotionResponse>  => {
            return this.httpClient.sendRequest<CreateSmartPromotionResponse>({
                path: '/deliveryProviderPortal/smartpromotions/v2/createSmartPromotion',
                service_id: 'merchant-portal-campaign-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public smartpromotionsV2GetCurrentSmartPromotion = async (body: GetCurrentSmartPromotionRequest, opts?: TRequestOptions): Promise<GetCurrentSmartPromotionResponse>  => {
            return this.httpClient.sendRequest<GetCurrentSmartPromotionResponse>({
                path: '/deliveryProviderPortal/smartpromotions/v2/getCurrentSmartPromotion',
                service_id: 'merchant-portal-campaign-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public smartpromotionsV2GetSmartPromotionConfig = async (body: GetSmartPromotionConfigRequest, opts?: TRequestOptions): Promise<SmartPromotionV2Config>  => {
            return this.httpClient.sendRequest<SmartPromotionV2Config>({
                path: '/deliveryProviderPortal/smartpromotions/v2/getSmartPromotionConfig',
                service_id: 'merchant-portal-campaign-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public smartpromotionsV2GetSmartPromotionDetails = async (body: GetSmartPromotionDetailsRequest, opts?: TRequestOptions): Promise<GetSmartPromotionDetailsResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionDetailsResponse>({
                path: '/deliveryProviderPortal/smartpromotions/v2/getSmartPromotionDetails',
                service_id: 'merchant-portal-campaign-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public smartpromotionsV2GetSmartPromotionPerformance = async (body: GetSmartPromotionPerformanceRequest, opts?: TRequestOptions): Promise<GetSmartPromotionPerformanceResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionPerformanceResponse>({
                path: '/deliveryProviderPortal/smartpromotions/v2/getSmartPromotionPerformance',
                service_id: 'merchant-portal-campaign-portal',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
